import { render, staticRenderFns } from "./CarteBuffetView.vue?vue&type=template&id=547a8134"
import script from "./CarteBuffetView.vue?vue&type=script&lang=js"
export * from "./CarteBuffetView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports